/**
 * A URL that addresses one task.
 *
 * It exists because a notification has to be clickable and, until now, nothing
 * in Atlas addressed a single task: the drawers opened from local state on
 * whichever list you happened to be looking at.
 *
 * Worth having on its own terms. This system deliberately sends no email, so
 * work gets passed around on WhatsApp, and `/t/<id>` is a link somebody can
 * paste into a message. Anyone who may not read the task gets the API's
 * ordinary 404, exactly as they would anywhere else.
 */
import { useNavigate, useParams } from 'react-router'
import { TaskDrawer } from '../components/TaskDrawer'
import { MyWorkPage } from './MyWorkPage'

export function TaskLinkPage() {
  const { taskId } = useParams<{ taskId: string }>()
  const navigate = useNavigate()

  if (!taskId) return null

  // Closing goes back where they came from when there is a history entry to go
  // back to, and to My work when the link was opened cold from a message.
  const close = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/', { replace: true })
  }

  // My work sits behind the drawer so a link opened cold from a message lands
  // in the app rather than on a panel floating over nothing, and closing it
  // leaves them somewhere useful.
  return (
    <>
      <MyWorkPage />
      <TaskDrawer taskId={taskId} onClose={close} />
    </>
  )
}
